module.exports = __webpack_public_path__ + "2e974871efeaf78aab57b561b17e8a8e.png";